import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const ChevronRight = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M10.2318 35.6402C9.87821 35.2159 9.93554 34.5853 10.3598 34.2318L27.438 20L10.3598 5.76822C9.93554 5.41466 9.87821 4.78409 10.2318 4.35982C10.5853 3.93554 11.2159 3.87821 11.6402 4.23178L29.6402 19.2318C29.8682 19.4218 30 19.7032 30 20C30 20.2968 29.8682 20.5782 29.6402 20.7682L11.6402 35.7682C11.2159 36.1218 10.5853 36.0645 10.2318 35.6402Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default ChevronRight;
